import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { ApiResponseCode } from 'src/app/core/enums';
import { AppData } from 'src/app/app.data';
import { Utils } from 'src/app/core/utils';
import { WaitlistModule } from './waitlist.module';
import { WaitlistFilterModel } from 'src/app/core/models/waitlist-filter-model';
import { WaitlistModel } from 'src/app/core/models/waitlist-model';

@Injectable({
  providedIn: 'root'
})
export class WaitlistService {

  settings: Settings;
  apiEndPoint: string =  Utils.getApiEndPoint(); // environment.APIEndpoint;

  constructor(
    private http: HttpClient,
    private router: Router,
    private appSettings: AppSettings,
    private appData: AppData) {

    this.settings = appSettings.settings;

  }

  loadItems(filterData: WaitlistFilterModel) {
      return this.http.post<any>(this.apiEndPoint + `StandbyAPI/GetWaitListItems`, filterData)
        .pipe(map(result => {
          return result;
        }));
  }


  removeItem(itemID: number) {
    return this.http.post<any>(this.apiEndPoint + `StandbyAPI/RemoveWaitListItem`, itemID)
      .pipe(map(result => {
        return result;
      }));
  }

  // editItem(item: WaitlistFilterModel) {
  //   return this.http.post<any>(this.apiEndPoint + `StandbyAPI/GetWaitListItems`, filterData)
  //     .pipe(map(result => {
  //       return result;
  //     }));
  // }

  // findTimeForItem(item: WaitlistFilterModel) {
  //   return this.http.post<any>(this.apiEndPoint + `StandbyAPI/GetWaitListItems`, filterData)
  //     .pipe(map(result => {
  //       return result;
  //     }));
  // }

}
